import React from 'react';

const OrderStatusBadge = ({ status }) => {
    const getStatusConfig = () => {
        switch (status) {
            case 'pending':
                return {
                    label: '等待接單',
                    bgColor: 'bg-yellow-100',
                    textColor: 'text-yellow-600'
                };
            case 'accepted':
                return {
                    label: '已接單',
                    bgColor: 'bg-blue-100',
                    textColor: 'text-blue-600'
                };
            case 'driver_arriving':
                return {
                    label: '司機前往中',
                    bgColor: 'bg-blue-100',
                    textColor: 'text-blue-600'
                };
            case 'in_progress':
                return {
                    label: '行程進行中',
                    bgColor: 'bg-blue-100',
                    textColor: 'text-blue-600'
                };
            case 'completed':
                return {
                    label: '已完成',
                    bgColor: 'bg-green-100',
                    textColor: 'text-green-600'
                };
            case 'cancelled':
                return {
                    label: '已取消',
                    bgColor: 'bg-red-100',
                    textColor: 'text-red-600'
                };
            default:
                return {
                    label: status,
                    bgColor: 'bg-gray-100',
                    textColor: 'text-gray-600'
                };
        }
    };

    const { label, bgColor, textColor } = getStatusConfig();

    return (
        <span className={`px-2 py-1 rounded-full text-xs ${bgColor} ${textColor}`}>
            {label}
        </span>
    );
};

export default OrderStatusBadge;